import { CreditCard, Wallet, Sparkles, Headphones, FileText, BarChart2, Calculator } from "lucide-react";

export function BillingTabs({ activeTab, onTabChange, hasActiveSubscription, t }) {
    const allTabs = [
        {
            id: "plans",
            labelKey: "billing.tabs.plans",
            fallback: "Plans",
            icon: CreditCard,
        },
        {
            id: "payment",
            labelKey: "billing.tabs.paymentMethods",
            fallback: "Payment Methods",
            icon: Wallet,
        },
        {
            id: "credits",
            labelKey: "billing.tabs.credits",
            fallback: "Credits",
            icon: Sparkles,
            requiresSubscription: true,
            badge: "billing.tabs.creditsBadge",
            badgeFallback: "New",
        },
        {
            id: "usage",
            labelKey: "billing.tabs.usage",
            fallback: "Usage",
            icon: BarChart2,
            requiresSubscription: true,
        },
        {
            id: "support",
            labelKey: "billing.tabs.support",
            fallback: "Support Plans",
            icon: Headphones,
            requiresSubscription: true,
        },
        {
            id: "invoices",
            labelKey: "billing.tabs.invoices",
            fallback: "Invoices",
            icon: FileText,
            requiresSubscription: true,
        },
        {
            id: "module-costs",
            labelKey: "billing.tabs.moduleCosts",
            fallback: "AI Capacity Estimator",
            icon: Calculator,
        },
    ];

    // Filter out tabs that require subscription if user doesn't have one
    const tabs = allTabs.filter(tab => {
        if (tab.requiresSubscription && !hasActiveSubscription) {
            return false;
        }
        return true;
    });

    return (
        <div className="mb-8">
            <div className="border-b border-gray-200 overflow-x-auto overflow-y-hidden">
                <nav
                    className="-mb-px flex space-x-4 md:space-x-8 min-w-max px-1"
                    aria-label="Billing tabs"
                >
                    {tabs.map((tab) => {
                        const Icon = tab.icon;
                        const isActive = activeTab === tab.id;

                        return (
                            <button
                                key={tab.id}
                                onClick={() => onTabChange(tab.id)}
                                className={`
                                    group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors
                                    ${
                                        isActive
                                            ? "border-blue-500 text-blue-600"
                                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                    }
                                `}
                                aria-current={isActive ? "page" : undefined}
                            >
                                <Icon
                                    className={`
                                        -ml-0.5 mr-2 h-5 w-5 transition-colors
                                        ${
                                            isActive
                                                ? "text-blue-500"
                                                : "text-gray-400 group-hover:text-gray-500"
                                        }
                                    `}
                                />
                                <span>{t(tab.labelKey) || tab.fallback}</span>
                                {tab.badge && (
                                    <span className="ml-2 px-2 py-0.5 text-xs font-semibold bg-blue-100 text-blue-700 rounded-full">
                                        {t(tab.badge) || tab.badgeFallback}
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </nav>
            </div>
        </div>
    );
}
